var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 68,
    viewBox: "0 0 96 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 11.25V3.25C73 2.14543 72.1046 1.25 71 1.25H25C23.8954 1.25 23 2.14543 23 3.25V11.25",
    stroke: "url(#paint0_linear_7970_9581)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.25 21.25V13.25C79.25 12.1454 78.3546 11.25 77.25 11.25H18.75C17.6454 11.25 16.75 12.1454 16.75 13.25V21.25",
    stroke: "url(#paint1_linear_7970_9581)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 36.25V23.25C85.5 22.1454 84.6046 21.25 83.5 21.25H12.5C11.3954 21.25 10.5 22.1454 10.5 23.25V36.25",
    stroke: "url(#paint2_linear_7970_9581)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 36.5625C63.25 44.8123 56.5623 51.5 48.3125 51.5V53.5C57.6668 53.5 65.25 45.9168 65.25 36.5625H63.25ZM64.5595 37.25H92.875V35.25H64.5595V37.25ZM93.875 38.25V64.25H95.875V38.25H93.875ZM92.875 65.25H3.125V67.25H92.875V65.25ZM2.125 64.25V38.25H0.125V64.25H2.125ZM3.125 37.25H32.0655V35.25H3.125V37.25ZM48.3125 51.5C40.0627 51.5 33.375 44.8123 33.375 36.5625H31.375C31.375 45.9168 38.9582 53.5 48.3125 53.5V51.5ZM32.0655 37.25C31.6724 37.25 31.375 36.9306 31.375 36.5625H33.375C33.375 35.8511 32.8018 35.25 32.0655 35.25V37.25ZM2.125 38.25C2.125 37.6977 2.57272 37.25 3.125 37.25V35.25C1.46815 35.25 0.125 36.5931 0.125 38.25H2.125ZM3.125 65.25C2.57272 65.25 2.125 64.8023 2.125 64.25H0.125C0.125 65.9069 1.46815 67.25 3.125 67.25V65.25ZM93.875 64.25C93.875 64.8023 93.4273 65.25 92.875 65.25V67.25C94.5319 67.25 95.875 65.9069 95.875 64.25H93.875ZM92.875 37.25C93.4273 37.25 93.875 37.6977 93.875 38.25H95.875C95.875 36.5931 94.5319 35.25 92.875 35.25V37.25ZM65.25 36.5625C65.25 36.9306 64.9526 37.25 64.5595 37.25V35.25C63.8232 35.25 63.25 35.8511 63.25 36.5625H65.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7970_9581",
    x1: 11.9163,
    y1: 5.56034,
    x2: 83.468,
    y2: 5.56036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6E87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F75DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7970_9581",
    x1: 2.89532,
    y1: 15.5603,
    x2: 92.335,
    y2: 15.5604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6E87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F75DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7970_9581",
    x1: -6.12562,
    y1: 27.7155,
    x2: 101.202,
    y2: 27.7155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6E87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F75DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-Icon.404be5267632dd847334afa6b990157e.svg";
export { ForwardRef as ReactComponent };